<template>
  <transition name="search-results-scroll-top-btn">
    <v-btn
      v-show="offsetTop > 500"
      id="search-results-scroll-top-btn"
      color="primary"
      fab
      @click="$vuetify.goTo(0)"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </transition>
</template>

<script>
export default {
  name: 'FlightSearchResultsScrollButton',
  props: {
    offsetTop: {
      type: Number,
      required: false
    }
  }
}
</script>

<style scoped>
  #search-results-scroll-top-btn {
    position: fixed;
    bottom: 3rem;
    right: 3rem;
    z-index: 9999;
  }

  .search-results-scroll-top-btn-enter-active {
    animation: search-results-scroll-top-btn 0.7s;
  }
  .search-results-scroll-top-btn-leave-active {
    transition: opacity 0.3s
  }
  .search-results-scroll-top-btn-enter, .search-results-scroll-top-btn-leave-to {
    opacity: 0;
  }

  @keyframes search-results-scroll-top-btn {
    from {
      transform: rotate(-90deg) scale(0);
    }
    to {
      transform: rotate(0deg) scale(1);
    }
  }

</style>
